import { Component, OnInit, ViewChild } from '@angular/core';
import { AdmService } from '../../../service/adm.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Globals } from 'src/app/globals';
import { environment } from 'src/environments/environment';
declare var $: any;

@Component({
  selector: 'app-summary-statistics-report',
  templateUrl: './summary-statistics-report.component.html',
  styleUrls: ['./summary-statistics-report.component.scss']
})
export class SummaryStatisticsReportComponent implements OnInit {

  showLoader: boolean = false;
  report: any;
  reportExportPdf = `${environment.API_URL_ADM}/api/summaryStatisticsPdf`;
  reportExportExcel = `${environment.API_URL_ADM}/api/summaryStatisticsExcel`;

  constructor(public globals: Globals, private admService: AdmService, private toastrService: ToastrService, public translate: TranslateService) { }

  ngOnInit(): void {
    this.getReport();
  }

  getReport() {
    this.showLoader = true;
    this.admService.getStatisticsReport().subscribe(
      data => {
        this.report = data
      },
      error => {
        this.updateTable();
        this.toastrService.error("can't get report");
        this.showLoader = false;
      },
      () => {
        this.showLoader = false;
        this.updateTable();
      }
    );
  }

  updateTable() {
    $("#datatable").DataTable().destroy();
    setTimeout(() => {
      $("#datatable").DataTable({
        // dom: 'Bfrtip',
        pagingType: 'simple_numbers',
        responsive: true,
        // columnDefs: [
        //   { responsivePriority: 1, targets: 0 },
        //   { responsivePriority: 10001, targets: 4 },
        //   { responsivePriority: 2, targets: -2 }
        // ],
        // "columnDefs": [
        //   { "orderable": false, "targets": [3] }
        // ],
        pageLength: 5,
        lengthChange: false,
        info: true,
        searching: false,
        // search: {
        //   searchPlaceholder: "Search",
        // },
        paging: true,
        // language: {
        //   search: "",
        //   searchPlaceholder: "Search",
        // },
        // buttons: [
        //   'excel', 'pdf'
        // ]
        // buttons: [{
        //   extend: 'csvHtml5',
        //   text: '<span style="font-size: 3em; color: green;"><i class="fas fa-file-excel fa-sm"></i></span>',
        //   titleAttr: 'CSV'
        // },
        // {
        //   extend: 'pdfHtml5',
        //   text: '<span style="font-size: 3em; color: #e04006;"><i class="fas fa-file-pdf fa-sm"></i></span>',
        //   titleAttr: 'PDF'
        // }]
      });
    }, 1);

  }

}
